module.exports = __webpack_public_path__ + "img/jamf_logo.0ba51fbc.svg";